<template>
  <div>
    <router-view/>
  </div>
</template>
<script >

import {mapGetters} from "vuex";

export default {
  name: "DashboardContainer",
  data:function (){
    return {
   canView:false
  }},
  mounted() {
    this.canView = this.isIndicaUser || this.isPNUDADMIN;
/*    if(!this.canView){
      this.$router.push({path:"/tracker-dashboard"})
    }*/
  },
  computed: {
    ...mapGetters([      "isPNUDADMIN",
      "isIndicaUser",])}
};
</script >

